import { z } from 'zod';

import { NetworkCategory, NetworkTypeEnum } from '@/constants/network';
import { OrderDirection } from '@/constants/orderDirection';

import { NetworkTableColumns } from './-table/type';

export const NetworkTableFilterSchema = z.object({
  sortOrder: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z
    .enum([
      NetworkTableColumns.NETWORK_NAME,
      NetworkTableColumns.NETWORK_TYPE,
      NetworkTableColumns.PURPOSE,
      NetworkTableColumns.ADMIN_CONTACT,
    ])
    .optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),

  freeText: z.string().optional(),
  networkCategory: z.nativeEnum(NetworkCategory).optional(),
  networkType: z.array(z.nativeEnum(NetworkTypeEnum)).optional(),
});
